import background_1 from '../assets/background/background_1.mp3';
import background_2 from '../assets/background/background_2.mp3';
import background_3 from '../assets/background/background_3.mp3';
import background_4 from '../assets/background/background_4.mp3';
import background_5 from '../assets/background/background_5.mp3';

const backgroundTracks = [
    background_1,
    background_2,
    background_3,
    background_4,
    background_5,
];

export default backgroundTracks;
